import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://dmnsynbxftuqmubdnhgw.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRtbnN5bmJ4ZnR1cW11YmRuaGd3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzMDgyMTMsImV4cCI6MjA3NTg4NDIxM30.9AgTlIKIoh-1Kt8BqTZWxsnav4WuWhpQF0i_JBVzLgo';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storageKey: 'foodline-warehouse-auth', // Unique key for warehouse app
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  global: {
    headers: {
      'x-application-name': 'foodline-warehouse'
    }
  }
});
